import React from 'react';
import styled from 'styled-components';
import logoImage from '../assets/images/logo.png';

const MobileApp: React.FC = () => {
  return (
    <Container id="mobile-app">
      <Background />
      <Content>
        <Header>
          <Title>Flinstones RestoCafe Mobil Uygulaması</Title>
          <Subtitle>
            Rezervasyondan özel menülere, tüm hizmetlerimiz artık cep telefonunuzda!
          </Subtitle>
        </Header>

        <MainContent>
          <LeftSection>
            <PhoneMockup>
              <PhoneScreen>
                <AppIcon>
                  <img src={logoImage} alt="Flinstones RestoCafe Logo" />
                </AppIcon>
                <AppTitle>Flinstones App</AppTitle>
                <AppDescription>
                  Rezervasyon, menü ve daha fazlası
                </AppDescription>

                <Features>
                  <Feature>
                    <FeatureIcon>★</FeatureIcon>
                    <FeatureText>Anında Rezervasyon</FeatureText>
                  </Feature>
                  <Feature>
                    <FeatureIcon>♨</FeatureIcon>
                    <FeatureText>Canlı Menü</FeatureText>
                  </Feature>
                  <Feature>
                    <FeatureIcon>♦</FeatureIcon>
                    <FeatureText>Özel Teklifler</FeatureText>
                  </Feature>
                </Features>

                <DownloadButtons>
                  <DownloadButton 
                    as="a" 
                    href="https://apps.apple.com/tr/app/fppremiumrestocafe/id6749573675?l=tr"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AppleIcon>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                      </svg>
                    </AppleIcon>
                    <div>
                      <span>Download on the</span>
                      <strong>App Store</strong>
                    </div>
                  </DownloadButton>
                  <DownloadButton 
                    as="a" 
                    href="/fppremiumv1.0.apk"
                    download="FlintstonesPremium.apk"
                  >
                    <GoogleIcon>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                      </svg>
                    </GoogleIcon>
                    <div>
                      <span>Get it on</span>
                      <strong>Google Play</strong>
                    </div>
                  </DownloadButton>
                </DownloadButtons>
              </PhoneScreen>
            </PhoneMockup>
          </LeftSection>

          <RightSection>
            <FeaturesList>
              <Feature>
                <FeatureIcon>📋</FeatureIcon>
                <FeatureContent>
                  <FeatureTitle>Dijital Menü</FeatureTitle>
                  <FeatureDescription>
                    Güncel menümüzü, fiyatları ve özel günün yemeklerini mobil uygulamamızdan kolayca inceleyin.
                  </FeatureDescription>
                </FeatureContent>
              </Feature>

              <Feature>
                <FeatureIcon>🍝</FeatureIcon>
                <FeatureContent>
                  <FeatureTitle>Ana Yemekler</FeatureTitle>
                  <FeatureDescription>
                    Dünya mutfağından seçkin lezzetler: pasta, pizza, grill çeşitleri ve geleneksel Türk yemekleri.
                  </FeatureDescription>
                </FeatureContent>
              </Feature>

              <Feature>
                <FeatureIcon>🥗</FeatureIcon>
                <FeatureContent>
                  <FeatureTitle>Sağlıklı Seçenekler</FeatureTitle>
                  <FeatureDescription>
                    Vejetaryen, vegan ve diyet menü seçenekleri ile herkesin zevkine uygun lezzetler.
                  </FeatureDescription>
                </FeatureContent>
              </Feature>

              <Feature>
                <FeatureIcon>🍰</FeatureIcon>
                <FeatureContent>
                  <FeatureTitle>Tatlılar & İçecekler</FeatureTitle>
                  <FeatureDescription>
                    Ev yapımı tatlılar, özel kahve çeşitleri ve serinletici içecekler.
                  </FeatureDescription>
                </FeatureContent>
              </Feature>
            </FeaturesList>
          </RightSection>
        </MainContent>
      </Content>
    </Container>
  );
};

// Styled Components
const Container = styled.section`
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 4rem 0;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--soft-beige) 0%, var(--light-brown) 100%);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 30%, rgba(212, 175, 55, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 70%, rgba(139, 115, 85, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 50% 50%, rgba(245, 242, 237, 0.3) 0%, transparent 50%);
  }
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--primary-color);
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: var(--dark-color);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
  opacity: 0.8;
`;

const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
`;

const LeftSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PhoneMockup = styled.div`
  width: 300px;
  height: 600px;
  background: linear-gradient(145deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%);
  border-radius: 45px;
  padding: 15px;
  position: relative;
  box-shadow: 
    0 25px 60px rgba(0, 0, 0, 0.4),
    0 8px 16px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    inset 0 0 20px rgba(0, 0, 0, 0.2);
  
  /* Dynamic Island */
  &::before {
    content: '';
    position: absolute;
    top: 25px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 30px;
    background: #000;
    border-radius: 20px;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  /* Home indicator */
  &::after {
    content: '';
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 140px;
    height: 5px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }
  
  /* Side buttons */
  &:before {
    content: '';
    position: absolute;
    right: -3px;
    top: 120px;
    width: 3px;
    height: 60px;
    background: linear-gradient(180deg, #333, #111);
    border-radius: 0 2px 2px 0;
  }
`;

const PhoneScreen = styled.div`
  width: 100%;
  height: calc(100% - 35px);
  background: linear-gradient(180deg, var(--soft-beige) 0%, #F0EDE6 100%);
  border-radius: 32px;
  padding: 1.8rem 1.4rem 1.2rem 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 35px;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      rgba(255, 255, 255, 0.1) 0%, 
      rgba(255, 255, 255, 0.05) 50%, 
      rgba(0, 0, 0, 0.02) 100%);
    pointer-events: none;
  }
`;

const AppIcon = styled.div`
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.2rem;
  position: relative;
  z-index: 2;
  box-shadow: 
    0 8px 25px rgba(139, 115, 85, 0.3),
    0 2px 8px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      rgba(255, 255, 255, 0.2) 0%, 
      rgba(255, 255, 255, 0.0) 50%, 
      rgba(0, 0, 0, 0.1) 100%);
    border-radius: inherit;
  }
  
  img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    border-radius: 8px;
    position: relative;
    z-index: 1;
  }
`;

const AppTitle = styled.h3`
  font-size: 1.6rem;
  margin-bottom: 0.6rem;
  color: var(--primary-color);
  position: relative;
  z-index: 1;
  font-weight: 700;
`;

const AppDescription = styled.p`
  color: var(--dark-color);
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  opacity: 0.8;
  line-height: 1.4;
`;

const Features = styled.div`
  width: 100%;
  margin-bottom: 1.2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.8rem;
`;

const Feature = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0;
  padding: 0.7rem 0.8rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 2;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      rgba(255, 255, 255, 0.1) 0%, 
      rgba(255, 255, 255, 0.0) 100%);
    border-radius: inherit;
    pointer-events: none;
  }
`;

const FeatureIcon = styled.div`
  width: 35px;
  height: 35px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  font-size: 1rem;
  color: white;
  font-weight: bold;
  flex-shrink: 0;
`;

const FeatureText = styled.span`
  color: var(--dark-color);
  font-weight: 600;
  font-size: 0.85rem;
  position: relative;
  z-index: 2;
`;

const DownloadButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  width: 100%;
  justify-content: space-between;
  margin-top: auto;
`;

const DownloadButton = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
  padding: 0.6rem 0.8rem;
  border-radius: 8px;
  font-size: 0.7rem;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1;
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  text-decoration: none;
  
  &:hover {
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
    transform: translateY(-1px);
    box-shadow: 
      0 6px 16px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    color: white;
    text-decoration: none;
  }
  
  &:visited {
    color: white;
    text-decoration: none;
  }
  
  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    span {
      font-size: 0.6rem;
      opacity: 0.8;
      line-height: 1;
    }
    
    strong {
      font-size: 0.7rem;
      font-weight: 600;
      line-height: 1;
    }
  }
`;

const AppleIcon = styled.div`
  margin-right: 0.5rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 18px;
    height: 18px;
  }
`;

const GoogleIcon = styled.div`
  margin-right: 0.5rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 18px;
    height: 18px;
  }
`;

const RightSection = styled.div``;

const FeaturesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const FeatureContent = styled.div`
  flex: 1;
`;

const FeatureTitle = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 0.8rem;
  color: var(--primary-color);
  font-weight: 600;
`;

const FeatureDescription = styled.p`
  color: var(--dark-color);
  line-height: 1.6;
  opacity: 0.8;
`;

export default MobileApp;